import { createAsyncThunk } from '@reduxjs/toolkit';
import { completeInvoicePayment } from '../services/completeInvoicePayment.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const completeInvoicePaymentThunk = createAsyncThunk(
  'payments/completeInvoicePayment',
  async ({ projectId, invoiceId }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    return await completeInvoicePayment(
      projectId,
      invoiceId,
      activeEmployerInfo
    );
  }
);
